export const darkTheme = {
  background1: '#030712',
  background2: '#0B1220',
  text: '#FFFFFF',
  subText: '#C7CBD1',
  button: '#00A3E0',
  stroke: '#1B253A',
  labelbg: '#207558',
  labelstroke: '#1E4839',
  textgreen: '#e8fff8',
  greenbg: '#059669',
  gray: '#6B7280',
  white: '#FFFFFF',
  border: '#eff4ff',
  suspectedbg: '#992a2a',
  suspectedstroke: '#D14444',
  suspectedlabel: '#EC5B5B',
  textsuspected: '#e8fff8',
  expiredbg: '#855228',
  expiredstroke: '#EC995B',
  expiredlabel: '#955B30',
  textexpired: '#e8fff8',
  redbg: '#644324',
  redstroke: '#EC995B',
  redlabel: '#955B30',
  textred: '#e8fff8',
  spinner: '#cdeeff',
};

export const lightTheme = {
  background1: '#ecf0f3',
  background2: '#FFFFFF',
  text: '#0B1220',
  subText: '#5A5F6A',
  button: '#0077B6',
  stroke: '#E5E7EB',
  labelbg: '#19975D',
  labelstroke: '#BBF5DA',
  textgreen: '#e5fff7',
  greenbg: '#059669',
  gray: '#6B7280',
  white: '#FFFFFF',
  border: '#eff4ff',
  suspectedbg: '#a01a1a',
  suspectedstroke: '#FFC3C3',
  suspectedlabel: '#d93535',
  textsuspected: '#eee8e8',
  expiredbg: '#DA6610',
  expiredstroke: '#FFE0C3',
  expiredlabel: '#fc750e',
  textexpired: '#ffffff',
  spinner: '#b8d7e6',
};
